import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiInput']
>['styleOverrides'] = {
  input: {
    minWidth: 150,
  },
};

const MuiInput: Components<CssVarsTheme>['MuiInput'] = {
  styleOverrides,
};

export default MuiInput;
